/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import PreguntaForm from './PreguntaForm';
import * as validations from '../../validations/validations';
import * as preguntaActions from '../../actions/preguntaActions';
import * as formularioActions from '../../actions/formularioActions';
import * as respuestaActions from '../../actions/respuestaActions';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown, genericFormattedForDropdownTexto} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';

class ManageExamenPreguntaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			pregunta:{
                    },
            opcion:{texto1:''},
            fileReg:'',
            respuestas:[],
            imagen:{},
            questionPic:{},
            idOpcion:0,
            tipoRespuesta:[{id:1, value:"single", texto1:"Simple"}, {id:2, value:"multiple", texto1:"Multiple"}],
            tipoPregunta:[{id:1, value:"text", texto1:"Texto"}, {id:2, value:"photo", texto1:"Imagenes"}]
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'Examen', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        /*
        if(id && id>0 ){
            
           this.props.preguntaActions.getPregunta(id, this.props.user).then( pregunta=>{
               this.setState({"pregunta":pregunta});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        */
        
        this.props.formularioActions.getFormularioCombo(this.props.user).then()
            .catch(error=>{
              toastr.error(error);
            }); 
        
        
		
    }
    
    componentWillReceiveProps(nextProps) {	
        
       if(nextProps.id!=this.props.id){
           this.cargar(nextProps.id);
       }
	  
	}
    
    
    cargar=(id)=>{
        
        if(id && id>0 ){
            //console.log("cargar");    
            //console.log(id);
            this.props.preguntaActions.getPregunta(id, this.props.user).then( pregunta=>{
  
                   this.state.respuestas = pregunta.respuestaList;
                    this.setState({"pregunta":pregunta});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }else{
            let pregunta = this.state.pregunta;
            
            
            this.setState({pregunta:[]});
            
            
            pregunta.nombre=" ";
            pregunta.point=0;
            pregunta.explanation=" ";
            pregunta.messageForCorrect="";
            pregunta.messageForIncorrect=" ";
            pregunta.answerSelectionType=null;
            
            this.setState({pregunta:pregunta, respuestas:[]});
        }
    }
   
    

    handleChange=(event, data)=> {

        let pregunta = this.state.pregunta;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		pregunta[field[0]]= value;
		else{
             if(!pregunta[field[0]]){
                    pregunta[field[0]]={}
                }
			pregunta[field[0]][field[1]]= value;
		}
        
		
        this.setState({"pregunta": pregunta});
    }
    
    
    handleChangeMultiple=(event, data)=> {
	
        let value =	data.value;		
        let opcion = this.state.opcion;
        
        if(data.slider){
            if(data.checked){
                value = 1;
            }else{
                value = 0;
            }
            opcion.correctAnswer = value;
        }else{
            
            opcion.texto1 = value;
            opcion.value="";
            //opcion.pregunta_id = this.state.registro.id;
        }
        this.setState({"opcion": opcion});
    }
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let pregunta=this.state.pregunta;
        /*        
        if(!validations.requerido(pregunta.idFormulario)){
            errors.idFormulario=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pregunta.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pregunta.tipo)){
            errors.tipo=true;
            formIsValid=false;
        }
        */
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }


     handleChangeFile=(event, data)=> {
        let tamano;
        let imagen = this.state.imagen;
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';

            this.setState({"fileReg": ''});
            this.setState({"imagen": imagen});
            return;
        }


        if(event.target.files[0].size<=(1024*1024)*2){
            imagen['fileReg'] = event.target.files[0];
            imagen['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            this.setState({"fileReg": '1'});
            this.setState({"imagen": imagen});
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';
            this.setState({"fileReg": ''});
            this.setState({"imagen": imagen});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+"Mb. No se permiten imagnees mayores a 5 Mb!!!");
            return;
        } 
         
     }
     
     handleFile=(event, data)=> {
        let tamano;
        let questionPic = this.state.questionPic;
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            questionPic.fileReg = '';
            questionPic.imagePreviewUrl='';

            this.setState({"fileReg": ''});
            this.setState({"questionPic": questionPic});
            return;
        }


        if(event.target.files[0].size<=(1024*1024)*2){
            questionPic['fileReg'] = event.target.files[0];
            questionPic['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            this.setState({"fileReg": '1'});
            this.setState({"questionPic": questionPic});
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            questionPic.fileReg = '';
            questionPic.imagePreviewUrl='';
            this.setState({"fileReg": ''});
            this.setState({"questionPic": questionPic});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+"Mb. No se permiten imagnees mayores a 2 Mb!!!");
            return;
        } 
         
     }

    

    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        this.state.pregunta.idFormulario = this.props.idForm;
        
        this.props.preguntaActions.save(this.state.pregunta, this.props.user).then((preguntaGuardado) => {
            toastr.success("Registro guardado!!!.");
            
            this.cargar(preguntaGuardado.id);
            
            /*************************/
            /* GUARDADO DE IMAGEN DE LA PREGUNTA */
            
            
                    var questionPic = this.state.questionPic.fileReg;


                    if(questionPic instanceof File){

                        var form_data = new FormData();
                        form_data.append('file', questionPic);
                        form_data.append('preguntaId', preguntaGuardado.id);

                        this.props.preguntaActions.saveQuestionImage(form_data, this.props.user).then((imagen) => {

                            toastr.success("Imagen guardada correctamente!!!.");
                            let pregunta = this.state.pregunta;
                            pregunta.preguntaImagen = imagen.descripcion;
                            this.setState({pregunta:pregunta});
                            

                        }).catch(error=>{
                          toastr.error(error.responseJSON.message);
                        });

                    }

            
            
            /*************************/
            
            this.props.inicializa();
        });
        
    }
    
    onSaveImagenRespuesta=(event)=>{
        event.preventDefault();
        
        var imagen = this.state.imagen.fileReg;
        var respuestaId = 0;
        var correctAnswer=0;
        if(this.state.opcion.id){
            respuestaId = this.state.opcion.id;
        }
        if(this.state.opcion.correctAnswer){
            correctAnswer = this.state.opcion.correctAnswer;
        }
        
        if(imagen instanceof File){

             var form_data = new FormData();
            form_data.append('file', imagen);
            form_data.append('preguntaId', this.state.pregunta.id);
            form_data.append('respuestaId', respuestaId);
            form_data.append('correctAnswer', correctAnswer);
            
         
            
            this.props.preguntaActions.saveImage(form_data, this.props.user).then(() => {

                toastr.success("Imagen guardada correctamente!!!.");

            }).catch(error=>{
              toastr.error(error.responseJSON.message);
            });
            
        }
        
    }
    
    onDeleteImagenPregunta=(event)=>{
        event.preventDefault();
        
            if(this.state.pregunta.id>0){
                this.props.preguntaActions.deleteQuestionImage(this.state.pregunta.id, this.props.user).then(() => {
                    let pregunta = this.state.pregunta;
                    toastr.success("Imagen borrada correctamente!!!.");
                    pregunta.preguntaImagen=null;
                    this.setState({pregunta:pregunta});
                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });
                
            }
        
    }
    
    
    agregarOpcion=()=>{
        let opcion = Object.assign({}, this.state.opcion);
        let respuestas = this.state.respuestas
        //let registro = this.state.registro;
        
        if(opcion.texto1.trim()){
            if(!opcion.id){
                opcion.id = this.state.idOpcion-1;
                this.setState({idOpcion:opcion.id});
                respuestas.push(Object.assign({}, opcion));
            }else{
                let index = respuestas.findIndex(r=>r.id==opcion.id); 
                //console.log(index);
                //console.log(opcion.texto1);
                /*
                //console.log(opcion.id);
                //console.log(respuestas[-1]);
                respuestas[index].id = opcion.id; 
                respuestas[index].texto1 = opcion.texto1;
                respuestas[index].correcto = opcion.correcto;
                */
            }
            
            this.setState({respuestas:respuestas});
            opcion.texto1 = "";
            opcion.correctAnswer="";
            opcion.id=0;
            this.setState({opcion:opcion});
        }else{
            
            toastr.error('Debes escribir una respuesta');
            
        }
    }
    
    
    onBorrar=(id)=>{
        
        let respuestas = this.state.respuestas;
        let borrar = 0;
        //console.log(id);
        let index = respuestas.findIndex(r=>r.id==id);  
            if(respuestas[index].id>0){
                //console.log("se manda para borrar");
                this.props.respuestaActions.borrar(id, this.props.user).then((borrado) => {
                    toastr.success("Registro borrado!!!.");
                    respuestas.splice( index, 1 );   
                    this.setState({respuestas:respuestas});
            
                });
                
            }else{
                respuestas.splice( index, 1 );   
                this.setState({respuestas:respuestas});
            }  
        
      
            
            
    }
    
    onCorrecto=(id)=>{
        
        let respuestas = this.state.respuestas;
        //console.log(id);
        let index = respuestas.findIndex(r=>r.id==id);  
            if(respuestas[index].id>0){
                //console.log("se manda para borrar");
                this.props.respuestaActions.activar(id, this.props.user).then((activar) => {
                    //console.log("activar");
                    //console.log(activar);
                    toastr.success("Registro actualizado!!!.");   
                    //this.setState({respuestas:respuestas});
                    respuestas[index].correctAnswer= activar.correctAnswer;
                    this.setState({respuestas:respuestas});
            
                });
                
            }  
        
      
            
            
    }

    onEditar=(id)=>{
        
        let respuestas = this.state.respuestas;
        let index = respuestas.findIndex(r=>r.id==id);  
       
        let opcion = respuestas[index];
        this.setState({"opcion": opcion});
       
    }
       
    render() {	
          
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <div>
                <PreguntaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.pregunta}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    opcion={this.state.opcion}
                    onChangeMultiple={this.handleChangeMultiple}
                    onChangeFile={this.handleChangeFile}
                    agregarOpcion={this.agregarOpcion}
                    respuestas={this.state.respuestas}
                    onBorrar={this.onBorrar}
                    onEditar={this.onEditar}
                    tipoRespuesta={genericFormattedForDropdownTexto(this.state.tipoRespuesta)}
                    tipoPregunta={genericFormattedForDropdownTexto(this.state.tipoPregunta)}
                    onSaveImangenR={this.onSaveImagenRespuesta}
                    onCorrecto={this.onCorrecto}
                    onHandleFile={this.handleFile}
                    deleteImagenPregunta={this.onDeleteImagenPregunta}    
                />

            </div> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let idForm = ownProps.match.params.idForm;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        //id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        formularioCombo:state.formularioCombo,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            preguntaActions: bindActionCreators(preguntaActions, dispatch),
            formularioActions:bindActionCreators(formularioActions, dispatch),
            respuestaActions:bindActionCreators(respuestaActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageExamenPreguntaForm);